import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/app-skeleton';
import { FEED_CARD_RESTING_OUTLINE } from '@/lib/ui/feed-card-chrome';
import { cn } from '@/lib/ui/utils';
import type { ProposalFeedCardVariant } from './proposal-feed-card';
function skeletonVisibilityClasses(variant: ProposalFeedCardVariant): string {
  switch (variant) {
    case 'mobile':
      return 'md:hidden flex flex-col gap-3';
    case 'tablet':
      return 'hidden md:flex lg:hidden flex-col gap-3 h-full min-h-0';
    case 'compact':
      return 'flex flex-col gap-3 h-full min-h-0';
    default:
      {
        const _exhaustive: never = variant;
        return _exhaustive;
      }
  }
}
export interface ProposalFeedCardSkeletonProps {
  variant: ProposalFeedCardVariant;
}

/** Matches `ProposalFeedCard` block structure for loading placeholders. */
export function ProposalFeedCardSkeleton(t0) {
  const $ = _c(21);
  const {
    variant
  } = t0;
  let t1;
  if ($[0] !== variant) {
    t1 = cn(skeletonVisibilityClasses(variant), "rounded-card bg-background-primary px-4 py-4", FEED_CARD_RESTING_OUTLINE);
    $[0] = variant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = variant === "mobile" ? "rounded-overlay-item" : "rounded-control";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("size-12 shrink-0", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Skeleton className={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-1.5 min-w-0 flex-1"><Skeleton className="h-4 w-3/4" /><Skeleton className="h-4 w-1/2" /></div>;
    t6 = <Skeleton className="h-5 w-16 shrink-0" />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4) {
    t7 = <div className="flex items-start gap-3 min-w-0">{t4}{t5}{t6}</div>;
    $[8] = t4;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex flex-col gap-1.5"><Skeleton className="h-4 w-2/3" /><Skeleton className="h-1.5 w-full rounded-full" /></div>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Skeleton className="size-7 shrink-0 rounded-full" />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex items-center gap-2 min-w-0 flex-1">{t9}<div className="flex flex-col gap-1 min-w-0 flex-1"><Skeleton className="h-4 w-1/2" /><Skeleton className="h-3 w-1/3" /></div></div>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex flex-col items-end gap-1"><Skeleton className="h-4 w-8" /><Skeleton className="h-3 w-12" /></div>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex items-center gap-4 min-w-0">{t10}<div className="flex items-center gap-2 shrink-0">{t11}<div className="flex items-center"><Skeleton className="size-7 shrink-0 rounded-full" /><Skeleton className="size-7 shrink-0 rounded-full -ml-3.5" /><Skeleton className="size-7 shrink-0 rounded-full -ml-3.5" /></div></div></div>;
    t13 = <div className="h-[0.5px] w-full bg-border-primary my-1" aria-hidden="true" />;
    $[14] = t12;
    $[15] = t13;
  } else {
    t12 = $[14];
    t13 = $[15];
  }
  let t14;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex flex-col gap-1 min-w-0 flex-1"><Skeleton className="h-4 w-1/3" /><Skeleton className="h-3 w-1/4" /></div>;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="flex items-center justify-between gap-3">{t14}<div className="flex items-center gap-1 shrink-0"><Skeleton className="size-6 rounded-control" /><Skeleton className="h-4 w-8" /><Skeleton className="size-6 rounded-control" /></div></div>;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t1 || $[19] !== t7) {
    t16 = <div className={t1} aria-hidden="true">{t7}{t8}{t12}{t13}{t15}</div>;
    $[18] = t1;
    $[19] = t7;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  return t16;
}